import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

// Inline layout for the Empty Locations search filters (columns available in EmptyLocationDTO).
const EmptyLocationSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Warehouse",
                "tableName": "",
                "label": "Warehouse",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "Location",
                "tableName": "",
                "label": "Location",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ClassCode",
                "tableName": "",
                "label": "Class",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "SubClassCode",
                "tableName": "",
                "label": "Sub Class",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Description",
                "tableName": "",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    }
];

const EmptyLocationFilters = (props) => {
    const [selectedItems, setSelectedItems] = useState([]);
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        Warehouse: '',
        Location: '',
        ClassCode: '',
        SubClassCode: '',
        Description: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );

    const handleFormSubmit = () => {
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {
    }, []);
    const handleReset = () => {
        setformFields(initialFormFields);
        props.searchData(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSearchFormLoad = useCallback(() => {
        // No lookups needed yet - filters are plain text for now.
    }, []);

    return (
        <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => {
                if (e.currentTarget === e.target) {
                    selectionChanged(e, e.target);
                }
            }}
            itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                    <Item location="before">
                        <div className="title">
                            <h6
                                style={{
                                    color: window._env_.Color2
                                }}
                            >
                                Location Management - (Empty Locations)
                            </h6>
                        </div>
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                </Toolbar>
            )}
            itemRender={() => (
                <div>
                    <FormField
                        currrentUser={currentUser}
                        layoutId='D4E5F6A7-B8C9-40D1-8E2F-3A4B5C6D7E8F'
                        layoutName='LocationManagementEmptyLocationForm'
                        defaultFormSchema={EmptyLocationSearchFormLayout}
                        formFields={formFields}
                        setformFields={setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handleSearchFormLoad}
                        noSpacingBeforeFirstRow={true}
                    />
                </div>
            )}
            id="accordion-container" className="accordion-height"
        />
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EmptyLocationFilters);
